export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAIL = 'PRODUCT_LIST_FAIL';

export const PRODUCT_PROFILE_REQUEST = 'PRODUCT_PROFILE_REQUEST';
export const PRODUCT_PROFILE_SUCCESS = 'PRODUCT_PROFILE_SUCCESS';
export const PRODUCT_PROFILE_FAIL = 'PRODUCT_PROFILE_FAIL';

export const PRODUCT_TOP_REQUEST = 'PRODUCT_TOP_REQUEST';
export const PRODUCT_TOP_SUCCESS = 'PRODUCT_TOP_SUCCESS';
export const PRODUCT_TOP_FAIL = 'PRODUCT_TOP_FAIL';

export const PRODUCT_FAVOURITE_REQUEST = 'PRODUCT_FAVOURITE_REQUEST';
export const PRODUCT_FAVOURITE_SUCCESS = 'PRODUCT_FAVOURITE_SUCCESS';
export const PRODUCT_FAVOURITE_FAIL = 'PRODUCT_FAVOURITE_FAIL';

export const PRODUCT_UNFAVOURITE_REQUEST = 'PRODUCT_UNFAVOURITE_REQUEST';
export const PRODUCT_UNFAVOURITE_SUCCESS = 'PRODUCT_UNFAVOURITE_SUCCESS';
export const PRODUCT_UNFAVOURITE_FAIL = 'PRODUCT_UNFAVOURITE_FAIL';

export const PRODUCT_CATEGORY_REQUEST = 'PRODUCT_CATEGORY_REQUEST';
export const PRODUCT_CATEGORY_SUCCESS = 'PRODUCT_CATEGORY_SUCCESS';
export const PRODUCT_CATEGORY_FAIL = 'PRODUCT_CATEGORY_FAIL';

export const PRODUCT_CREATE_REVIEW_REQUEST = 'PRODUCT_CREATE_REVIEW_REQUEST';
export const PRODUCT_CREATE_REVIEW_SUCCESS = 'PRODUCT_CREATE_REVIEW_SUCCESS';
export const PRODUCT_CREATE_REVIEW_FAIL = 'PRODUCT_CREATE_REVIEW_FAIL';
export const PRODUCT_CREATE_REVIEW_RESET = 'PRODUCT_CREATE_REVIEW_RESET';

export const TROLLEY_ADD_ITEM = 'TROLLEY_ADD_ITEM';
export const TROLLEY_REMOVE_ITEM = 'TROLLEY_REMOVE_ITEM';
export const TROLLEY_SAVE_DELIVERY_ADDRESS = 'TROLLEY_SAVE_DELIVERY_ADDRESS';
export const TROLLEY_SAVE_DELIVERY_DATE = 'TROLLEY_SAVE_DELIVERY_DATE';
export const TROLLEY_SAVE_PAYMENT_METHOD = 'TROLLEY_SAVE_PAYMENT_METHOD';
export const TROLLEY_RESET = 'TROLLEY_RESET';

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL';
export const USER_PROFILE_RESET = 'USER_PROFILE_RESET';

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST';
export const USER_UPDATE_PROFILE_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS';
export const USER_UPDATE_PROFILE_FAIL = 'USER_UPDATE_PROFILE_FAIL';

export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST';
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCCESS';
export const ORDER_CREATE_FAIL = 'ORDER_CREATE_FAIL';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';
export const ORDER_DETAILS_RESET = 'ORDER_DETAILS_RESET';

export const ORDER_USER_LIST_REQUEST = 'ORDER_USER_LIST_REQUEST';
export const ORDER_USER_LIST_SUCCESS = 'ORDER_USER_LIST_SUCCESS';
export const ORDER_USER_LIST_FAIL = 'ORDER_USER_LIST_FAIL';
export const ORDER_USER_LIST_RESET = 'ORDER_USER_LIST_RESET';

export const ORDER_PAY_REQUEST = 'ORDER_PAY_REQUEST';
export const ORDER_PAY_SUCCESS = 'ORDER_PAY_SUCCESS';
export const ORDER_PAY_FAIL = 'ORDER_PAY_FAIL';
export const ORDER_PAY_RESET = 'ORDER_PAY_RESET';

export const ADMIN_USER_LIST_REQUEST = 'ADMIN_USER_LIST_REQUEST';
export const ADMIN_USER_LIST_SUCCESS = 'ADMIN_USER_LIST_SUCCESS';
export const ADMIN_USER_LIST_FAIL = 'ADMIN_USER_LIST_FAIL';
export const ADMIN_USER_LIST_RESET = 'ADMIN_USER_LIST_RESET';

export const ADMIN_USER_DELETE_REQUEST = 'ADMIN_USER_DELETE_REQUEST';
export const ADMIN_USER_DELETE_SUCCESS = 'ADMIN_USER_DELETE_SUCCESS';
export const ADMIN_USER_DELETE_FAIL = 'ADMIN_USER_DELETE_FAIL';

export const ADMIN_USER_PROFILE_REQUEST = 'ADMIN_USER_PROFILE_REQUEST';
export const ADMIN_USER_PROFILE_SUCCESS = 'ADMIN_USER_PROFILE_SUCCESS';
export const ADMIN_USER_PROFILE_FAIL = 'ADMIN_USER_PROFILE_FAIL';
export const ADMIN_USER_PROFILE_RESET = 'ADMIN_USER_PROFILE_RESET';

export const ADMIN_USER_UPDATE_PROFILE_REQUEST =
	'ADMIN_USER_UPDATE_PROFILE_REQUEST';
export const ADMIN_USER_UPDATE_PROFILE_SUCCESS =
	'ADMIN_USER_UPDATE_PROFILE_SUCCESS';
export const ADMIN_USER_UPDATE_PROFILE_FAIL = 'ADMIN_USER_UPDATE_PROFILE_FAIL';
export const ADMIN_USER_UPDATE_PROFILE_RESET =
	'ADMIN_USER_UPDATE_PROFILE_RESET';

export const ADMIN_PRODUCT_DELETE_REQUEST = 'ADMIN_PRODUCT_DELETE_REQUEST';
export const ADMIN_PRODUCT_DELETE_SUCCESS = 'ADMIN_PRODUCT_DELETE_SUCCESS';
export const ADMIN_PRODUCT_DELETE_FAIL = 'ADMIN_PRODUCT_DELETE_FAIL';

export const ADMIN_PRODUCT_CREATE_REQUEST = 'ADMIN_PRODUCT_CREATE_REQUEST';
export const ADMIN_PRODUCT_CREATE_SUCCESS = 'ADMIN_PRODUCT_CREATE_SUCCESS';
export const ADMIN_PRODUCT_CREATE_FAIL = 'ADMIN_PRODUCT_CREATE_FAIL';
export const ADMIN_PRODUCT_CREATE_RESET = 'ADMIN_PRODUCT_CREATE_RESET';

export const ADMIN_PRODUCT_UPDATE_REQUEST = 'ADMIN_PRODUCT_UPDATE_REQUEST';
export const ADMIN_PRODUCT_UPDATE_SUCCESS = 'ADMIN_PRODUCT_UPDATE_SUCCESS';
export const ADMIN_PRODUCT_UPDATE_FAIL = 'ADMIN_PRODUCT_UPDATE_FAIL';
export const ADMIN_PRODUCT_UPDATE_RESET = 'ADMIN_PRODUCT_UPDATE_RESET';

export const ADMIN_ORDER_LIST_REQUEST = 'ADMIN_ORDER_LIST_REQUEST';
export const ADMIN_ORDER_LIST_SUCCESS = 'ADMIN_ORDER_LIST_SUCCESS';
export const ADMIN_ORDER_LIST_FAIL = 'ADMIN_ORDER_LIST_FAIL';

export const ADMIN_ORDER_DELIVERED_REQUEST = 'ADMIN_ORDER_DELIVERED_REQUEST';
export const ADMIN_ORDER_DELIVERED_SUCCESS = 'ADMIN_ORDER_DELIVERED_SUCCESS';
export const ADMIN_ORDER_DELIVERED_FAIL = 'ADMIN_ORDER_DELIVERED_FAIL';
export const ADMIN_ORDER_DELIVERED_RESET = 'ADMIN_ORDER_DELIVERED_RESET';
